import BannerWithCTA from "./components/banner-with-cta.ux";
import CollectionsUX from "./components/collections.ux";
import CustomSelect from "./components/custom-select";
import FAQAccordionUX from "./components/faq-accordion.ux";
import FeatureHeroUX from "./components/feature-hero.ux";
import FeaturedCollectionUX from "./components/featured-collection.ux";
import FooterUX from "./components/footer.ux";
import FormsUX from "./components/forms.ux";
import HeaderUX from "./components/header.ux";
import ImageWithTextUX from "./components/image-with-text.ux";
import MobileMediaGalleryUX from "./components/mobile-media-gallery.ux";
import ProductBundleUX from "./components/product-bundle.ux";
import adjustFontSize from './components/product-headlines.ux';
import ProductListingWidgetUX from "./components/product-listing-widget.ux";
import ProductPageUX from "./components/product-page.ux";
import ProductShowcaseUX from "./components/product-showcase.ux";
import ProductVideoUX from "./components/product-video.ux";
import RichTextUX from "./components/rich-text.ux";
import HorizontalScrollLogoUX from "./components/horizontal-scrolling-images.ux";
import KlaviyoReviewsUX from "./components/klaviyo-reviews.ux";
// import ProductAccordionUX from "./components/product-accordion.ux";
import CartDrawer from "./components/cart-drawer.ux";

$(document).ready(function() {
    CartDrawer();
    CustomSelect();
    FormsUX();
    HeaderUX();
    FooterUX();
    MobileMediaGalleryUX();
    FeatureHeroUX();
    ImageWithTextUX();
    RichTextUX();
    adjustFontSize();
    ProductListingWidgetUX();
    BannerWithCTA();
    ProductShowcaseUX();
    FAQAccordionUX();
    CollectionsUX();
    ProductPageUX();
    ProductBundleUX();
    ProductVideoUX();
    HorizontalScrollLogoUX();
    KlaviyoReviewsUX();
    FeaturedCollectionUX();
    // console.log("Calling ProductAccordionUX");
    // ProductAccordionUX();
});
